import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import svgHtaBg from '@img/general/hta-inner-bg-pattern.svg';
import RichTextStyles from '@stories/Widgets/RichText/RichText.styles';
import styled from 'styled-components';
import HeadingStyles from '../Global/Typography/Heading.styles';
import ParagraphStyles from '../Global/Typography/Paragraph.styles';
import SectionWrapper from '../SectionWrapper/SectionWrapper';
const Container = styled(SectionWrapper) `
  ${setCssVar('accentColor', brand.hta.green)};
  ${setCssVar('accentColorAlt', brand.hta.greenLight)};
  ${setCssVar('bgColor', brand.hta.greenLight)};
  ${setCssVar('fgColor', brand.black)};

  display: flex;
  background: ${cssVar('bgColor')};
  min-height: 300px;
  padding: 32px 0;

  /* HTA Shamrock Background */
  @media ${until(Device.Tablet)} {
    background-image: url('${svgHtaBg}'), url('${svgHtaBg}');
    background-repeat: repeat-x, repeat-x;
    background-position: bottom left, bottom 50px left 30px;
    background-size: 125px 50px;
  }

  /* HTA Shamrock Background */
  @media ${from(Device.Tablet)} {
    background-image: url('${svgHtaBg}'), url('${svgHtaBg}');
    background-repeat: repeat-x, repeat-x;
    background-position: bottom left, bottom 100px left 60px;
    background-size: 250px 100px;
  }
`;
const Inner = styled.div `
  position: relative;
  height: 100%;
  justify-content: center;
`;
const ContentWrapper = styled.div `
  background: ${brand.white};
  border-radius: 19px;
  filter: drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.16));
  max-width: 666px;
  padding: 12px 28px 32px 28px;

  @media ${from(Device.Tablet)} {
    padding: 40px 48px 40px 64px;
  }
`;
const Title = styled.h1 `
  ${HeadingStyles.H2Styles};
  margin: 0 0 16px;

  @media ${from(Device.Tablet)} {
    margin: 0 0 24px;
  }
`;
const Content = styled.div `
  ${RichTextStyles.contentStyles};
  margin: 0 0 16px;

  @media ${from(Device.Tablet)} {
    margin: 0 0 32px;
  }
`;
const ModeList = styled.div `
  display: flex;
  align-items: center;
  margin: 0 0 24px;
`;
const ModeItem = styled.label `
  position: relative;
  display: block;

  & + & {
    margin-left: 24px;
  }

  @media ${from(Device.Tablet)} {
    & + & {
      margin-left: 56px;
    }
  }
`;
const ModeInput = styled.input `
  ${srOnly}
`;
const ModeText = styled.span `
  display: block;
  ${ParagraphStyles.SmallStyles};
  margin: 0;
  padding: 0 0 0 32px;

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    border-radius: 50%;
    box-sizing: border-box;
    height: 25px;
    width: 25px;
  }

  &::before {
    border: 1px solid ${cssVar('fgColor')};
    z-index: 1;
  }

  &::after {
    background: ${cssVar('accentColor')};
    background-clip: content-box;
    opacity: 0;
    padding: 4px;
    transition: opacity 0.15s ease-out;
    z-index: 2;
  }

  ${ModeInput}:checked + &::after {
    opacity: 1;
  }
`;
const FieldWrapper = styled.div ``;
const FieldLabel = styled.label `
  ${srOnly}
`;
export default {
    Container,
    Content,
    ContentWrapper,
    FieldLabel,
    FieldWrapper,
    Inner,
    ModeInput,
    ModeItem,
    ModeList,
    ModeText,
    Title,
};
